// set active column on page load (for mobile)
$('.pricing').each(function () {
   let $columns = $(this).find('.pricing__columns'),
       $features = $(this).find('.pricing__features');

   if ($columns.find('.column--highlight').length > 0) {
      // check if highlighted column exists and set as active

      let $highlight = $columns.find('.column--highlight'),
          columnIndex = $highlight.index();

      $highlight.addClass('column--active');

      $features.find('.feature').each(function () {
         $(this).find('.feature__state').eq(columnIndex-1).addClass('feature__state--active');
      });

   } else {
      // set first column/state as active

      $columns.each(function () {
         $(this).find('.column').first().addClass('column--active');
      });

      $features.find('.feature').each(function () {
         $(this).find('.feature__state').first().addClass('feature__state--active');
      });

   }
});

$('.pricing__control').on('click', function () {
   let $pricing = $(this).closest('.pricing'),
       $columns = $pricing.find('.pricing__columns'),
       $features = $pricing.find('.pricing__features'),
       activeIndex = $pricing.find('.column--active').index();

   if ($(this).attr('class').indexOf('prev') >= 0) {
      // previous button

      let newIndex = activeIndex - 1;

      $columns.each(function () {
         $(this).find('.column').eq(newIndex-1).addClass('column--active').siblings().removeClass('column--active');
      });

      $features.find('.feature').each(function () {
         $(this).find('.feature__state').eq(newIndex-1).addClass('feature__state--active').siblings().removeClass('feature__state--active');
      });
   } else {
      // next button

      let newIndex = activeIndex + 1;

      if (newIndex > $columns.first().find('.column').length) {
         newIndex = 1;
      }

      $columns.each(function () {
         $(this).find('.column').eq(newIndex-1).addClass('column--active').siblings().removeClass('column--active');
      });

      $features.find('.feature').each(function () {
         $(this).find('.feature__state').eq(newIndex-1).addClass('feature__state--active').siblings().removeClass('feature__state--active');
      });

   }
});

// expanding/collapsing feature groups
$('.feature__toggle').on('click', function () {
   let $toggle = $(this),
       classToggled = 'feature__toggle--toggled',
       $group = $(this).closest('.feature').next('.feature-group--collapsed');

   if ($toggle.hasClass(classToggled)) {
      $group.stop().slideUp(150);
      $toggle.removeClass(classToggled);
   } else {
      $toggle.addClass(classToggled);
      $group.stop().slideDown(150);
   }
});